export function popupSetGlobalKey(key,value) {
	return {
				type: 'POPUP_SET_GLOBAL_KEY',
				payload:{key,value}
			}
}

export function popupRemoveRule(key) {
	return {
				type: 'POPUP_REMOVE_RULE',
				payload:key
			}
}
export function popupSetRule(key,value) {
	return {
				type: 'POPUP_SET_RULE',
				payload:{key,value}
			}
}

export function popupSetSettingData(key,value) {
	return {
				type: 'POPUP_SET_SETTING_DATA',
				payload:{key,value}
			}
}


export function popupSetContentData(key,value) {
	return {
				type: 'POPUP_SET_CONTENT_DATA',
				payload:{key,value}
			}
}

export function popupSetStyleData(selector,key,value) {
	return {
				type: 'POPUP_SET_STYLE_DATA',
				payload:{selector,key,value}
			}
}

export function popupSetPopupKey(key,value) {
	return {
				type: 'POPUP_SET_POPUP_KEY',
				payload:{key,value}
			}
}

export function popupSetStyle(key,value) {
	return {
				type: 'POPUP_SET_STYLE',
				payload:{key,value}
			}
}

export function popupSetComponentData(key,value) {
	return {
				type: 'POPUP_SET_COMPONENT_DATA',
				payload:{key,value}
			}
}


// WEBPACK FOOTER //
// ./actions/builderPopup.js